import type { MessageKind } from "./schemas/messages";

export type ContactPolicyContact = {
  phone: string | null;
  email: string | null;
  smsConsent: number | boolean;
  emailOptOut: number | boolean;
  dnc: number | boolean;
};
export type ContactPolicyCode = "contact_required" | "phone_missing" | "email_missing" | "dnc" | "sms_consent_required" | "email_opt_out";
export type ContactPolicyResult = { allowed: true; code: null; reason: null } | { allowed: false; code: ContactPolicyCode; reason: string };

/** The same decision drives server sends and all manual UI controls. Booking eligibility is verified by the server. */
export function contactPolicy(contact: ContactPolicyContact | null, channel: "sms" | "email" | "call", options: { kind?: MessageKind; templateKey?: string | null; activeBooking?: boolean } = {}): ContactPolicyResult {
  const kind = options.kind ?? "manual";
  if (kind === "staff_alert") return { allowed: true, code: null, reason: null };
  if (!contact) return { allowed: false, code: "contact_required", reason: "Select a contact first." };
  if (channel === "email" ? !contact.email?.trim() : !contact.phone?.trim()) return channel === "email"
    ? { allowed: false, code: "email_missing", reason: "This contact has no email address." }
    : { allowed: false, code: "phone_missing", reason: "This contact has no phone number." };
  const marketing = kind === "manual" || kind === "drip" || (kind === "system" && options.templateKey !== "lead_ack");
  if (contact.dnc && (marketing || !options.activeBooking)) return { allowed: false, code: "dnc", reason: "Do not contact is enabled for this contact." };
  if (marketing && channel === "sms" && !contact.smsConsent) return { allowed: false, code: "sms_consent_required", reason: "SMS consent is required before texting this contact." };
  if (marketing && channel === "email" && contact.emailOptOut) return { allowed: false, code: "email_opt_out", reason: "This contact has opted out of email." };
  return { allowed: true, code: null, reason: null };
}
